<template>
  <div
    class="z-index-max"
    :class="[isMobile?'nav-bar ':'nav-bar-w' ]"
    :style="navBarStyle"
  >
   <!-- :class="[{ 'bottom-line': pageName }]" -->
    <!-- { 'iphonex-top': isIphoneX }, -->
    <div class="left" @click="$emit('onLeftClick')">
      <!-- 默认状态 -->
      <img
        v-if="isDefault && isShowBack"
        src="@img/back-white.svg"
        alt=""
        srcset=""
      />
      <!-- 定制具名插槽 -->
      <slot name="nav-left"></slot>
    </div>
    <div class="center">
      <!-- 默认状态 -->
      <span class="page-title" v-if="isDefault">{{ pageName }}</span>
      <!-- 定制具名插槽 -->
      <slot name="nav-center"></slot>
    </div>
    <div class="right">
      <!-- 定制具名插槽 -->
      <slot name="nav-right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 是否展示默认状态
    isDefault: {
      default: true,
      type: Boolean
    },
    // 是否展示默认后退按钮
    isShowBack: {
      default: true,
      type: Boolean
    },
    // 默认状态下页面标题的名称
    pageName: {
      default: "",
      type: String
    },
    // navBar样式
    navBarStyle: {
      type: Object,
      default: function() {
        return {
          backgroundColor: "white"
        };
      }
    }
  },
  data: function() {
    return {
      isIphoneX: window.isIphoneX,
      isMobile:true,
    };
  },
  created(){
     
     
    this.isMobile = this.isMobileF();

  },
  methods:{
   isMobileF() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }

  }
 
};
</script>

<style lang="scss" scoped>
@import "@css/style.scss";
.nav-bar {
  width: 100%;
  z-index: 9999;
  // height: $navBarHeight;
  // line-height: $navBarHeight;
  height: 1.3rem;
  line-height: 1.3rem;
  display: flex;
  align-items: center;
  // justify-content: space-between;
  // 适配手机 stateBar
  // padding-top: $stateBarHeight;

  background: linear-gradient(0deg, #269ca8 0%, #6ac6ba 100%);
  // justify-content: space-around;
 
  }
  .nav-bar-w{


  width: 100%;
  z-index: 9999;

  height: 1.3rem;
  line-height: 1.3rem;
  display: flex;
  align-items: center;
justify-content: space-between;

  background: linear-gradient(0deg, #269ca8 0%, #6ac6ba 100%);

  }

   .left {
    display: flex;
    height: 100%;
    width: px2rem(30);
    padding: 0 8px;

    img {
      width: 100%;
      align-self: center;
    }
  .right {
    display: flex;
    height: 100%;
    width: auto;
    padding: 0 8px;
    text-align: center;
    img {
      width: 100%;
      align-self: center;
    }
  }

  .center {
    display: flex;
    height: 100%;
    // flex-grow: 0.75;
    width: 6.5rem;
    justify-content: center;
    align-items: center;
    .page-title {
      align-self: center;
      margin: 0 auto;
      font-size: $titleSize;
    }
  }
}

.bottom-line {
  border-bottom: 1px solid $lineColor;
}
</style>
